<template>
  <div class="rules-page" v-loading.fullscreen.lock="loading">
    <el-row>

      <el-col>
        <div class="page-header">
          <h1 class="h1 page-title" v-if="places.heading">{{ places.heading.value }}</h1>
          <h2 class="h2 page-subtitle" v-if="places.header">{{ places.header.value }}</h2>
          <h3 class="h3">This sheet will cover common violations for <strong v-if="code">{{ code.building.name }}</strong></h3>
        </div>
      </el-col>

      <el-col>
        <div class="rules-content">
          <el-form>
            <ol>
              <li v-for="(rule, index) in rules" :key="index" >
                <p>{{ rule.value }}</p>
                <el-form-item>
                  <el-checkbox 
                    v-model="agrees[index].value"
                    border
                    @click.native="validationErr = false">
                    I agree
                  </el-checkbox>
                </el-form-item>
              </li>
  
              <el-alert
                v-if="validationErr"
                title="Error alert"
                type="error"
                description="Error: You must agree to all rules to proceed. All boxes must be Please make sure all boxes"
                show-icon>
              </el-alert>
            </ol>
            <p v-if="places.footer"><strong>{{ places.footer.value }}</strong></p>
            <p v-if="places.signatory"><i>{{ places.signatory.value }}</i></p>
          </el-form>
        </div>
      </el-col>

      <el-col>
        <user-vehicle-form />
      </el-col>

      <el-col>
        <div class="page-controls">
          <el-button type="primary" @click="$router.go(-1)" icon="el-icon-arrow-left" :disabled="loading">Back</el-button>
          <el-button @click="goNextPage" type="primary" :loading="loading" :disabled="loading">Continue<i class="el-icon-arrow-right"></i></el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BuildingRuleService from '../services/building-rule-service'
import ComputedStorage from '../mixins/computed-storage'
import CheckCode from '../mixins/check-code'
import UserVehicleForm from '../components/user-vehicle-form'

export default {
  mixins: [CheckCode, ComputedStorage],
  components: {UserVehicleForm},
  data() {
    return {
      loading: true,
      validationErr: false,
      agrees: [],
      rules:[],
      places: {
        heading: null,
        header: null,
        footer: null,
        signatory: null
      },
      code: null,
    }
  },

  watch: {
    code(newVal, oldVal) {
      if (oldVal !== null)
        return false

      BuildingRuleService.getList(this.code.building.id, this.invitationCode).then(response => {
        for (let rule of response.data.rule) {
          this.rules.push(rule)
          this.agrees.push({
            rule_id: rule.id,
            value: false,
          })
        }

        this.places.heading = response.data.heading[0]
        this.places.header = response.data.header[0]
        this.places.footer = response.data.footer[0]
        this.places.signatory = response.data.signatory[0]

        this.loading = false
      }).catch(err => {
        throw new Error('Error in "BuildingRuleService": ', err)
      })
    }
  },

  methods: {

    goNextPage () {
      for(let agree of this.agrees) {
        if (agree.value == false) {
          this.validationErr = true
          return false
        }
      }

      this.loading = true

      if (this.rulesUrl){
        this.$router.push({ name:'GuestRegistrationConsent', query: { code: this.invitationCode } })
        return true
      }
      
      const data = this.createValidData()

      BuildingRuleService.agree(data).then(response => {
        if (!response.data.created){
          this.loading = false
          throw new Error('Error in "BuildingRuleService"')
        }

        this.$store.commit('registration/setRulesUrl', response.data.resource.link)

        let route = this.code.building.consent.required ? { name:'GuestRegistrationConsent', query: { code: this.invitationCode } } : {name: 'GuestRegistrationThanks'}
        this.$router.push(route)
      }).catch(error => {
        this.loading = false
        throw new Error('Error in "BuildingRuleService": ', error);
      })

    },
    createValidData() {
      let data = {
        code: this.invitationCode,
        guest_id: this.guestId,
        BuildingRule: {},
        vehicle_id: this.vehicleData.id,
      }

      for (let agree of this.agrees) {
        data.BuildingRule[agree.rule_id] = agree.value ? 1 : 0
      }
      return data
    }
  },

  created() {
    this.checkInviteCode(code => {
      this.code = code
    });
  }
}
</script>


<style lang="scss" scoped>
.h3 {
  color: teal;
}
li p {
  text-align: justify;
  line-height: 20px;
}
ol {
  padding-left: 16px;
}
@media screen and (max-width: 768px) {
  .page-controls {
    display: flex;
    justify-content: space-around;
  }
}
</style>
